import React from "react"
import translations from "../translations/en.yml"
import Layout from "../components/layout"
import "./index.css"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "bootstrap/dist/css/bootstrap.min.css"

const lang = "en"

const IndexPage = () => <Layout t={translations} lang={lang} />

export default IndexPage
